export default "__VITE_ASSET__1HGWI5QK__"